import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Login from "./components/Login/Login";
import Main from "./Main";
import "./App.css";
import Signup from "./components/Signup/Signup";
import Cookies from 'js-cookie';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("isDarkMode") || false
  );

  const [email, setEmail] = useState(Cookies.get('email'));
  const [password, setPassword] = useState('');
  const [showMobileMessage, setShowMobileMessage] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setShowMobileMessage(window.innerWidth < 768); // 768px is Tailwind's md breakpoint
    };

    handleResize(); // Check on initial load
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Language preference is managed by user toggle in Sidebar
  // Default to English (false) if cookie doesn't exist

  return (
    <>
    <span className='text-xs mt-4 text-left fixed bottom-2 right-2'>Powered by Atlantis Digital AI Lab</span>
      {showMobileMessage && (
        <div className="fixed inset-0 bg-white z-50 flex items-center justify-center p-4 text-center">
          <div className="bg-white p-6 rounded-lg max-w-sm w-full">
            <h2 className="text-xl font-bold mb-4 text-gray-900">Desktop Only</h2>
            <p className="">
              This application is optimized for desktop use. Please access it from a larger screen for the best experience.
            </p>
          </div>
        </div>
      )}
      <Router>
        <Routes>
          <Route path="/login" element={<Login isDarkMode={isDarkMode} email={email} password={password} setEmail={setEmail} setPassword={setPassword} />} />
          <Route path="/signup" element={<Signup isDarkMode={isDarkMode} />} />
          <Route
            path="/*"
            element={
              <Main isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} email={email} />
            }
          >
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
